import addRoute from '@/router/add-route';

const IntegrationList = () => import('@/modules/integrations/integration-list');
const IntegrationView = () => import('@/modules/integrations/integration-view');
const IntegrationForm = () => import('@/modules/integrations/integration-form');
const IntegrationCallback = () => import('@/modules/integrations/integration-callback');

const Integrations = [
    addRoute({
        name: 'integrations',
        path: '/integrations',
        component: IntegrationList,
        root: {label: 'Automations', name: 'automations'},
    }),

    addRoute({
        name: 'integration-view',
        path: '/integrations/:service',
        component: IntegrationView,
        root: {label: 'Automations', name: 'automations'},
    }),

    addRoute({
        name: 'integration-add',
        path: '/integrations/:service/add',
        component: IntegrationForm,
        root: {label: 'Automations', name: 'automations'},
    }),

    addRoute({
        name: 'integration-edit',
        path: '/integrations/:service/edit/:id',
        component: IntegrationForm,
        root: {label: 'Automations', name: 'automations'},
    }),

    addRoute({
        name: 'integration-callback',
        path: '/integrations/:service/callback',
        component: IntegrationCallback,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default Integrations;
